import React, { useState } from "react";
import {
  DEFAULT_USER_NAME,
  DEFAULT_USER_ROLE,
  HEADER_DROPDOWN_OPTIONS,
  HEADER_SEARCH_OPTIONS
} from "../../../constants";
import Datalist from "./Datalist";
import SearchInput from "../../common/SearchInput";
import UserDropdown from "../../common/UserDropdown";

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleSearch = (event) => {
  };

  return (
    <div className="header-fix">
      <div className="header-fix-inner">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-5">
              <SearchInput
                placeholder="Type to search..."
                onSearch={handleSearch}
              />
              <Datalist options={HEADER_SEARCH_OPTIONS} />
            </div>
            <div className="col-sm-4"></div>
            <div className="col-sm-3">
              <UserDropdown
                userName={DEFAULT_USER_NAME}
                userRole={DEFAULT_USER_ROLE}
                options={HEADER_DROPDOWN_OPTIONS}
                isOpen={isDropdownOpen}
                onToggle={toggleDropdown}
                hoveredIndex={hoveredIndex}
                onHover={setHoveredIndex}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
